export default __webpack_public_path__ + "static/media/SearchNoData.5036f7a1.svg";